import React, { useRef, useEffect, useState } from "react";
import SpotlightCard from "../Effects/SpotlightCard";
import CountUp from "../Effects/CountUp";
import DecryptedText from "../Effects/DecryptedText";
import { FaRegSmileBeam, FaAward, FaFolderOpen } from "react-icons/fa";
import { motion, useInView } from "framer-motion";

const AnimatedCard = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { threshold: 0.2, once: false });

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isInView) {
      setVisible(true);
    } else {
      setVisible(false); 
    }
  }, [isInView]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
      transition={{ duration: 0.6, delay }}
    >
      {children}
    </motion.div>
  );
};

const SpotlightCardDemo = () => {
  return (
    <section className="px-4 py-20 bg-white">
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

        {/* Card 1 */}
        <AnimatedCard delay={0}>
          <SpotlightCard
            className="bg-white p-6 rounded-2xl shadow-lg"
            spotlightColor="rgba(4, 5, 5, 0.2)"
          >
            <div className="flex flex-col items-start gap-3">
              <div className="text-white bg-black p-3 rounded-full">
                <FaFolderOpen size={24} />
              </div>
              <h3 className="text-4xl font-bebas text-black">
                <CountUp from={0} to={500} duration={1} />+
              </h3>
              <DecryptedText
                text="Projects Completed"
                animateOn="view"
                sequential
                revealDirection="start"
                className="text-xl font-bebas text-black"
                encryptedClassName="text-gray-400"
              />
            </div>
          </SpotlightCard>
        </AnimatedCard>

        {/* Card 2 */}
        <AnimatedCard delay={0.2}>
          <SpotlightCard
            className="bg-white p-6 rounded-2xl shadow-lg"
            spotlightColor="rgba(255, 102, 204, 0.2)"
          >
            <div className="flex flex-col items-start gap-3">
              <div className="text-white bg-black p-3 rounded-full">
                <FaRegSmileBeam size={24} />
              </div>
              <h3 className="text-4xl font-bebas text-black">
                <CountUp from={0} to={500} duration={1} />+
              </h3>
              <DecryptedText
                text="Happy Clients"
                animateOn="view"
                sequential
                revealDirection="start"
                className="text-xl font-bebas text-black"
                encryptedClassName="text-gray-400"
              />
            </div>
          </SpotlightCard>
        </AnimatedCard>

        {/* Card 3 */}
        <AnimatedCard delay={0.4}>
          <SpotlightCard
            className="bg-white p-6 rounded-2xl shadow-lg"
            spotlightColor="rgba(255, 204, 0, 0.2)"
          >
            <div className="flex flex-col items-start gap-3">
              <div className="text-white bg-black p-3 rounded-full">
                <FaAward size={24} />
              </div>
              <h3 className="text-4xl font-bebas text-black">
                <CountUp from={0} to={50} duration={1} />+
              </h3>
              <DecryptedText
                text="Awards Won"
                animateOn="view"
                sequential
                revealDirection="start"
                className="text-xl font-bebas text-black"
                encryptedClassName="text-gray-400"
              />
            </div>
          </SpotlightCard>
        </AnimatedCard>

      </div>
    </section>
  );
};

export default SpotlightCardDemo;
